import { List } from "antd";
import { useAuth } from "global/context/AuthenticationContext";

function NotificationDropdown() {
  const { listNoti, notiLoading } = useAuth();

  return (
    <div className="w-[300px] md:w-[450px] bg-white border border-[#eee] rounded-lg shadow-md">
      <List
        size="small"
        bordered={false}
        loading={notiLoading}
        dataSource={listNoti}
        style={{
          maxHeight: 500,
          overflowY: "auto",
        }}
        className="scrollbar-hide"
        renderItem={(item: any) => (
          <div className="p-2">
            <div className="h-[80px] border border-[#eee] rounded-lg shadow-lg px-1">
              <List.Item
                style={{ flexDirection: "column", alignItems: "flex-start" }}
              >
                <div className="text-[14px] font-semibold">{item.title}</div>
                <div className="overflow-hidden text-ellipsis whitespace-nowrap w-full text-[13px] font-light">
                  {item.message}
                </div>
              </List.Item>
            </div>
          </div>
        )}
      />
    </div>
  );
}

export default NotificationDropdown;
